export default __webpack_public_path__ + "static/media/Building-rafiki.07a69bb9.svg";